module.exports = __webpack_public_path__ + "img/ren.bbbc9f07.png";